export default __webpack_public_path__ + "static/media/img-0150-india-half-face.5c7fe188.png";